import { STATUS_TYPES_CLASSNAMES } from 'components/Status'
import { BTN_TXT } from 'constants/txt'
import { routes } from 'router'

export enum BANK_ACCOUNT_STATUS {
  CREATED = 'new',
  ERRORED = 'errored',
  PENDING = 'pending',
  VERIFICATION_FAILED = 'verificationFailed',
  VERIFIED = 'verified'
}

export const BANK_ACCOUNT_STATUS_LABELS = {
  [BANK_ACCOUNT_STATUS.CREATED]: 'Created',
  [BANK_ACCOUNT_STATUS.ERRORED]: 'Errored',
  [BANK_ACCOUNT_STATUS.PENDING]: 'Pending',
  [BANK_ACCOUNT_STATUS.VERIFICATION_FAILED]: 'Verification failed',
  [BANK_ACCOUNT_STATUS.VERIFIED]: 'Verified'
}

export const BANK_ACCOUNT_STATUS_TO_CLASSNAME = {
  [BANK_ACCOUNT_STATUS.CREATED]: STATUS_TYPES_CLASSNAMES.GRAY,
  [BANK_ACCOUNT_STATUS.ERRORED]: STATUS_TYPES_CLASSNAMES.DARKGRAY,
  [BANK_ACCOUNT_STATUS.PENDING]: STATUS_TYPES_CLASSNAMES.GRAY,
  [BANK_ACCOUNT_STATUS.VERIFICATION_FAILED]: STATUS_TYPES_CLASSNAMES.RED,
  [BANK_ACCOUNT_STATUS.VERIFIED]: STATUS_TYPES_CLASSNAMES.GREEN
}

export const BREADCRUMBS = (title: string) => [
  {
    children: 'My community',
    href: routes.myCommunity
  },
  {
    children: 'My organization',
    href: `${routes.myCommunity}${routes.myOrganization}`
  },
  {
    children: 'Bank accounts',
    href: `${routes.myCommunity}${routes.myOrganization}${routes.bankAccounts}`
  },
  {
    children: title
  }
]

export const BANK_ACCOUNT_STATUS_OPTIONS = [
  {
    label: 'Created',
    value: BANK_ACCOUNT_STATUS.CREATED
  },
  {
    label: 'Errored',
    value: BANK_ACCOUNT_STATUS.ERRORED
  },
  {
    label: 'Pending',
    value: BANK_ACCOUNT_STATUS.PENDING
  },
  {
    label: 'Verification failed',
    value: BANK_ACCOUNT_STATUS.VERIFICATION_FAILED
  },
  {
    label: 'Verified',
    value: BANK_ACCOUNT_STATUS.VERIFIED
  }
]

export const BankAccountsTableMenuItemsOptions = [
  {
    label: BTN_TXT.SEND_DEPOSITS,
    key: 'send_deposit'
  },
  {
    label: BTN_TXT.RE_TRIGGER_SENDING_DEPOSITS,
    key: 'resend_deposit'
  },
  {
    label: BTN_TXT.VERIFY_DEPOSITS,
    key: 'verify_deposit'
  },
  {
    label: BTN_TXT.SET_AS_DEFAULT,
    key: 'set_as_default_receivable_account'
  },
  {
    label: BTN_TXT.DELETE,
    key: 'delete'
  }
]
